"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteAssetSchema = void 0;
const zod_1 = require("zod");
const utils_1 = require("../utils");
const location_1 = require("./subschemas/location");
const propertyDetails_1 = require("./subschemas/propertyDetails");
const rentalDetails_1 = require("./subschemas/rentalDetails");
const investmentDetails_1 = require("./subschemas/investmentDetails");
const descriptions_1 = require("./subschemas/descriptions");
const images_1 = require("./subschemas/images");
const documents_1 = require("./subschemas/documents");
const loanInformation_1 = require("./subschemas/loanInformation");
const investorSettings_1 = require("./subschemas/investorSettings");
exports.CompleteAssetSchema = zod_1.z.preprocess(utils_1.removeNullUndefined, zod_1.z.object({
    id: zod_1.z.string(),
    tokenId: zod_1.z.string().optional(),
    partnerId: zod_1.z.string(),
    updatedAt: zod_1.z.string().optional(),
    type: zod_1.z.enum(utils_1.availableAssetTypes),
    location: location_1.LocationValidationSchema,
    propertyDetails: propertyDetails_1.PropertyDetailsValidationSchema,
    rentalDetails: rentalDetails_1.RentalDetailsValidationSchema,
    investmentDetails: investmentDetails_1.InvestmentDetailsValidationSchema,
    descriptions: descriptions_1.DescriptionValidationSchema,
    images: images_1.ImagesValidationSchema,
    documents: documents_1.DocumentsValidationSchema,
    loanInformation: loanInformation_1.LoanInformation.optional(),
    investorSettings: investorSettings_1.InvestorSettings.optional(),
}));
//# sourceMappingURL=completeAsset.js.map